import React from 'react';
import { Avatar, Button, Element } from '@/components/core';
import FollowButton from '@/components/core/components/organism/follow-button';
import { useLocalizedLinks } from '@/components/core/hooks';
import clsx from 'clsx';
import { UserType } from '@/@types';
import { Plural } from '@lingui/react/macro';
import * as styles from './user-card.styles';
import InternalLink from '../../organism/internal-link';

const UserCard: React.FC<{ user: UserType; hideFollow?: boolean; size?: number | string }> = ({ user, hideFollow = false, size = '60%' }) => {
  const links = useLocalizedLinks();

  return (
    <div className={styles.root}>
      <InternalLink href={links.profile(user).root}>
        <Avatar src={user.avatar} level={user.level?.name} size={size} className={styles.avatar} />
      </InternalLink>
      <span className={styles.info}>
        {user.name && (
          <InternalLink lines={1} href={links.profile(user).root} className={clsx(styles.name)}>
            {user.name} {user.lastname}
          </InternalLink>
        )}
        {user.nickname && (
          <InternalLink lines={1} href={links.profile(user).root} className={clsx(styles.nickname)}>
            {user.nickname}
          </InternalLink>
        )}
        {(user.recommendations?.total || 0) > 0 && (
          <Element lines={1} className={styles.recommendations}>
            <Plural value={user.recommendations!.total} one="# recomendation" other="# recommendations" />
          </Element>
        )}
      </span>
      {!hideFollow && (
        <FollowButton className={styles.followButton} as={Button} isFollowed={user.isFollowed} variant={user.isFollowed ? 'secondary' : 'primary'} />
      )}
    </div>
  );
};

export default UserCard;
